<script setup>
defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: 'Disclaimer' }
});

const emit = defineEmits(['close']);
const close = () => emit('close');
</script>

<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ title }}</h3>
        <button class="modal-close" @click="close">Close</button>
      </div>
      <div class="modal-body doc">
        <h2>Disclaimer</h2>

        <p>This website (“Site”) is presented to you by Vivek Gupta, a registered investment advisor having registration number INA000020554, valid from July 2025 to Perpetual, with the Securities and Exchange Board of India (hereinafter referred to as “AssetNivesh”), for dissemination of information regarding services provided by AssetNivesh. By visiting this Site or downloading any content from this Site, you agree to abide by the terms and conditions (as may be amended, modified or supplemented from time to time) as set forth herein.</p>

        <p>This Site may contain data, articles, analyses, and forecasts etc. which are meant for general information and non-commercial purposes only.</p>

        <p>Terms and conditions provided herein are subject to change at any time without notice, at the discretion of AssetNivesh. AssetNivesh reserves the right to change, suspend, or discontinue any aspect of this Site at any time, including the availability of any Site feature, database, or content. Your continued usage of this Site following the posting of any change shall constitute acceptance of those changes on your part.</p>

        <p>The information contained on this Site represents a view (if any) as of the date of the post and is subject to change and/or withdrawal at any time without notice. The contents of this Site shall not be construed as an offer or a solicitation of an offer to invest in or buy or sell securities or instruments or to participate in any trading strategy or to make any investment. AssetNivesh is under no obligation to update the information provided after the publication date.</p>

        <p>Although the information and statistics included in this Site are not guaranteed including in respect of accuracy, they have been obtained from reliable sources. Any performance data quoted represents past performance. Investment return and principal value of an investment may fluctuate and therefore an investor’s shares or units of mutual funds, when redeemed, may be worth more or less than the principal invested. Past performance is no guarantee of future results. The use of the information provided on this Site is at the user’s risk.</p>

        <p>Information on this Site should not be construed, in any manner whatsoever, as the receipt of, or a substitute for, personalized individual advice from AssetNivesh.</p>

        <p>Use of links (“Hyperlinks”) to or from other internet sites may be included at times for the convenience of users. AssetNivesh assumes no responsibility for the content of any linked site. The fact that such links may exist does not indicate approval or endorsement of any material contained on any linked site.</p>

        <p>Any subsequent, direct communication with any prospective client shall be deemed to be valid communication on behalf of AssetNivesh only if conducted by an authorized representative of AssetNivesh.</p>

        <p>Special feature in the form of limited access/usage is available for this Site on subscription basis. Upon subscription, clients (“Limited Access Clients”) have the option to access through a personalized user account with a secure login id and password. Materials/information provided to such Limited Access Clients shall be solely for the use and benefit of such clients.</p>

        <p>Contents of the Site are specific to Indian Laws and Regulations. AssetNivesh shall not be liable for any content on the Site that may be violative of any other law or regulation pertaining to any other jurisdiction.</p>

        <p>Downloading any content from this Site is done at one’s own risk, and AssetNivesh shall not be responsible for any damage to any computer system or loss of data that results from the download of any material.</p>

        <p>The contents of this Site are the proprietary property of AssetNivesh. You shall not publish, copy, or otherwise reproduce any content for public/commercial use and/or distribution. Any attempt to reproduce or commercially distribute any part of the contents of this Site without the expressed written permission of AssetNivesh is strictly prohibited.</p>

        <p>Information provided by you through this Site is used for business purposes only in order to service your needs as a client. AssetNivesh may use “cookie” or related technology in order to track usage of the Site, and to in order to improve our service to you. Personal information that is submitted to this Site may be collected, processed, stored, disclosed and disposed of in accordance with applicable Indian laws and our internal policies.</p>

        <p>Any claim/dispute arising in connection with these terms and conditions or use of this Site shall be governed by and construed in accordance with the law of India and shall be subject to the exclusive jurisdiction of the courts at Delhi only.</p>

        <p>This Site is provided for financial literacy and general educational purposes. Nothing on this Site constitutes an offer to provide a product or service to every person or in every geographical location. Any services described may be subject to eligibility, applicable law, and a separate client engagement.</p>

        <p>Information on this Site should not be made the sole basis for any personal, investment, tax, legal, or financial decision. Users should obtain advice appropriate to their individual circumstances before acting.</p>

        <p>AssetNivesh does not guarantee that this Site, its functions, or access to it will be uninterrupted, error-free, secure, or free from technical defects. The Site may be unavailable, modified, or withdrawn at any time.</p>

        <p>To the fullest extent permitted by applicable law, AssetNivesh and Vivek Gupta shall not be liable for any direct, indirect, incidental, special, consequential, or other loss or damage arising from access to, use of, or inability to use this Site or information available through it.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.modal-content {
  width: 100%;
  max-width: 980px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.modal-header h3 { margin: 0; }
.modal-close { background: transparent; border: 0; cursor: pointer; color: #1f2937; font-weight: 700; }
.modal-body { padding: 16px 24px; overflow-y: auto; }
.doc { color: #1f2937; line-height: 1.6; font-size: 0.95rem; }
.doc h2 { font-size: 1.4rem; margin: 0 0 16px; }
.doc p { margin: 10px 0; }
</style>
